// Meta (Facebook) Pixel. Injected only for specific customers so they can track
// their public pages in Meta Ads. Keyed by page ID (i.e. the workspace ID of the
// company, returned by the fetch-for-filling API) — NOT the per-form ID — so the
// pixel applies to all of that company's public form pages.
const PAGE_PIXEL_MAP: Record<string, string> = {
	// PAGE_ID : PIXEL_ID
	'69e3208a128c242493ace265': '1536293007991460',
};

export function getPixelIdForPage(pageId: string | undefined): string | undefined {
	if (!pageId) return undefined;
	return PAGE_PIXEL_MAP[pageId];
}

// Only the events this customer needs for now. Expand into a proper feature
// (standard + custom events) if/when we generalize Meta Pixel tracking.
type MetaPixelEvent = 'PageView' | 'Lead';

type FbqFn = (action: 'track', eventName: MetaPixelEvent) => void;

function getFbq(): FbqFn | undefined {
	if (typeof window === 'undefined') return undefined;
	return (window as unknown as { fbq?: FbqFn })?.fbq;
}

/**
 * Fire a Meta Pixel event (e.g. 'Lead' on form submit).
 * No-ops safely if the pixel script never loaded (i.e. page has no configured pixel).
 */
export function trackPixelEvent(eventName: MetaPixelEvent) {
	try {
		const fbq = getFbq();
		if (!fbq) return;
		fbq('track', eventName);
		console.info(`[MetaPixel] tracked event: ${eventName}`);
	} catch (error) {
		console.error(`[MetaPixel] failed to track event: ${eventName}`, error);
	}
}

export function MetaPixel({ pixelId }: { pixelId: string }) {
	return (
		<script
			dangerouslySetInnerHTML={{
				__html: `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId}');
fbq('track', 'PageView');`,
			}}
		/>
	);
}
